const styles = {
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 0",
    borderBottom: "1px solid #eee",
  },
  name: {
    fontWeight: 500,
    marginBottom: 4,
  },
  priceRow: {
    display: "flex",
    gap: 8,
    alignItems: "center",
  },
  sellingPrice: {
    fontWeight: 600,
  },
  originalPrice: {
    textDecoration: "line-through",
    color: "#999",
    fontSize: 12,
  },
  counter: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  btn: {
    width: 28,
    height: 28,
    borderRadius: 6,
    border: "1px solid #ddd",
    background: "#fff",
    cursor: "pointer",
  },
  qty: {
    minWidth: 20,
    textAlign: "center",
  },
};

export default function PriceSelector({
  sku,
  selectedSlot,
  option,
  onChange,
  currency = "USD",
}) {

  const handleChange = (newQty) => {
    if (newQty < 0 || newQty > option.maxQty) return;
    onChange?.(newQty);
  };

  return (
    <div style={styles.container}>
      <div>
        <div style={styles.name}>{option.name}</div>

        <div style={styles.priceRow}>
          <span style={styles.sellingPrice}>{currency} {option.sellingPrice.toFixed(2)}</span>

          {option.originalPrice > option.sellingPrice && (
            <span style={styles.originalPrice}>
              {currency} {option.originalPrice.toFixed(2)}
            </span>
          )}
        </div>
      </div>

      <div style={styles.counter}>
        <button
          type="button"
          style={styles.btn}
          onClick={() => handleChange(option.quantity - 1)}
          disabled={(sku?.ticketType === 'Scheduled' && !selectedSlot) || option.quantity === 0}
        >
          -
        </button>

        <span style={styles.qty}>{option.quantity}</span>

        <button
          type="button"
          style={styles.btn}
          onClick={() => {handleChange(option.quantity + 1);}}
          disabled={(sku?.ticketType === 'Scheduled' && !selectedSlot) || option.quantity === option.maxQty}
        >
          +
        </button>
      </div>
    </div>
  );
}
